import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  button: {
    padding: '0',
    minWidth: '0',
    textTransform: 'lowercase',
  },
  link: {
    textDecoration: 'none',
    fontSize: '14px',
    color: '#00A1A1',
  }
};

const LinkToRelatedDomains = withStyles(styles)(({ record }) => {
    let domainLabel = '';

    if (record.domains) {
      domainLabel = `${record.domains.length} ${(record.domains.length > 1) ? 'domains' : 'domain'}`;
    }

    return <Button style={styles.button}>
        <Link style={styles.link} to={{
              pathname: `/websites/${encodeURIComponent(record.id)}`,
              }}>
          {domainLabel}
          </Link>
    </Button>
});
export default LinkToRelatedDomains;
